import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { isUndefined } from 'lodash';

const RadialChart = ({ orderStatusesCount }) => {
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState({});

  useEffect(() => {
    if (!isUndefined(orderStatusesCount.totalOrders)) {
      const total = orderStatusesCount.totalOrders || 0;
      const approved = orderStatusesCount.approvedOrders || 0;
      const dispatched = orderStatusesCount.dispatchedOrders || 0;
      const inTransit = orderStatusesCount.inTransitOrders || 0;
      const delivered = orderStatusesCount.deliveredOrders || 0;
      const pending = orderStatusesCount.pendingOrders || 0;
      const rejected = orderStatusesCount.rejectedOrders || 0;

      const approvedPct = total > 0 ? (approved / total) * 100 : 0;
      const dispatchedPct = total > 0 ? (dispatched / total) * 100 : 0;
      const inTransitPct = total > 0 ? (inTransit / total) * 100 : 0;
      const deliveredPct = total > 0 ? (delivered / total) * 100 : 0;
      const pendingPct = total > 0 ? (pending / total) * 100 : 0;
      const rejectedPct = total > 0 ? (rejected / total) * 100 : 0;

      setSeries([
        parseFloat(approvedPct.toFixed(1)),
        parseFloat(dispatchedPct.toFixed(1)),
        parseFloat(inTransitPct.toFixed(1)),
        parseFloat(deliveredPct.toFixed(1)),
        parseFloat(pendingPct.toFixed(1)),
        parseFloat(rejectedPct.toFixed(1)),
      ]);

      setOptions({
        chart: {
          height: 350,
          type: "radialBar",
        },
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 10,
              size: "30%",
            },
            track: {
              show: true,
              strokeWidth: "75%",
              margin: 6,
            },
            dataLabels: {
              name: {
                fontSize: "22px",
              },
              value: {
                fontSize: "16px",
              },
              total: {
                show: true,
                label: "Total",
                formatter: function () {
                  return total;
                },
              },
            },
          },
        },
        labels: ["Approved", "Dispatched", "In Transit", "Delivered", "Pending", "Rejected"],
        colors: ["#f1b44c", "#57BABA", "#50a5f1", "#34c38f", "#005254", "#FF6A56"],
      });
    }
  }, [orderStatusesCount]);

  return (
    <React.Fragment>
      <ReactApexChart
        options={options}
        series={series}
        type="radialBar"
        height="350"
        className="apex-charts"
      />
    </React.Fragment>
  );
};

export default RadialChart;
